import React, { useState } from "react"
import styled from "styled-components"
import * as FaIcons from "react-icons/fa"
import { SidebarData } from "./SidebarData"
import { SubMenu } from "./SubMenu"
import { Image, StyleSheet, TouchableOpacity, View } from "react-native"
import { COLORS } from "constants/Colors"
import { PrimaryText } from "components/Common/PrimaryText"
import { ChangePasswordModal } from "components/Modals/ChangePasswordModal"
import { useAuth } from "context/AuthContext"
import { logout } from "services/auth-service"
import { useDisplay } from "context/DisplayContext"
import { getUsersName } from "utils/helpers"

const SidebarNav = styled.nav`
  background: ${COLORS.primary.offWhite};
  width: ${({ sidebar, ismobile }) => ismobile ? "280px" : (sidebar ? "280px" : "60px")};
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  position: fixed;
  top: 0;
  left: ${({ sidebar, ismobile }) => (ismobile && !sidebar) ? "-280px" : "0"};
  transition: 350ms;
  z-index: 1000;
  font-family: Moranga;
  overflow: scroll;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.3);
`

const logo = require("assets/images/logo.png")

const Sidebar = () => {
  const { currentUser } = useAuth()
  const { showSidebar, setShowSidebar, toggleSidebar, isMobile, isTablet } = useDisplay()

  const [subnav, setSubnav] = useState(false)
  const [showProfileMenu, setShowProfileMenu] = useState(false)
  const [showChangePasswordModal, setShowChangePasswordModal] = useState(false)

  

  function logoutPressed() {
    logout()
    window.location.reload(false)
  }

  function changePasswordPressed() {
    setShowProfileMenu(false)
    setShowChangePasswordModal(true)
  }

  return (
    <>
      {/** MOBILE BACKDROP */}
      <div
        className={`sidebar-backdrop ${(isMobile || isTablet) && showSidebar ? "active" : ""}`}
        onClick={() => setShowSidebar(false)}
      />

      {/** TOP NAV */}
      <View style={[styles.topBar, {
        marginLeft: (isMobile || isTablet) ? 0 : (showSidebar ? 280 : 60),
        justifyContent: (isMobile || isTablet) ? "space-between" : "flex-end",
      }]}>

        {(isMobile || isTablet) && (
          <TouchableOpacity onPress={toggleSidebar} style={{ padding: 12 }}>
            <FaIcons.FaBars size={22} color={COLORS.primary.darkGray} />
          </TouchableOpacity>
        )}

        <TouchableOpacity
          style={styles.userContainer}
          onPress={() => setShowProfileMenu(!showProfileMenu)}
        >
          <View style={styles.userIcon}>
            {currentUser?.profilePic ? (
              <Image
                source={currentUser?.profilePic}
                style={styles.profilePic}
              />
            ) : (
              <FaIcons.FaUser size={20} color={COLORS.primary.white} />
            )}
          </View>
          <View style={{ flex: 1, marginHorizontal: 24 }}>
            <PrimaryText
              fontSize={14}
              fontWeight={300}
              style={styles.userName}
              numberOfLines={1}
            >
              {getUsersName(currentUser)}
            </PrimaryText>
            {!!currentUser?.role && (
              <PrimaryText
                fontSize={12}
                fontWeight={300}
                style={styles.userName}
                numberOfLines={1}
              >Admin
              </PrimaryText>
            )}
          </View>
          <FaIcons.FaChevronDown size={20} color={COLORS.primary.darkGray} />
        </TouchableOpacity>
      </View>

      <SidebarNav sidebar={showSidebar} ismobile={isMobile || isTablet ? 1 : 0}>
        <View
          style={{
            width: "100%",
            flex: 1,
            paddingBottom: 12,
          }}
        >
          {(isMobile || isTablet) && (
            <View style={{ flexDirection: "row", justifyContent: "flex-end", alignItems: "center", paddingRight: 12, paddingTop: 8 }}>
              <Image
                source={logo}
                style={{
                  height: 30,
                  width: 50,
                  resizeMode: "contain",
                  marginRight: "auto",
                  marginLeft: 12,
                }}
              />
              <TouchableOpacity
                style={{ padding: 12 }}
                onPress={() => setShowSidebar(false)}
              >
                <FaIcons.FaTimes size={20} color={COLORS.primary.darkBlue} />
              </TouchableOpacity>
            </View>
          )}
          <View>
            {!(isMobile || isTablet) && (
              <View style={styles.companyInfoContainer}>
                <View
                  style={[
                    styles.rayzeContainer,
                    !showSidebar && { justifyContent: "center" },
                  ]}
                >
                  <Image
                    source={logo}
                    style={[
                      styles.logo,
                      !showSidebar && { marginBottom: 0, height: 30, width: 50 },
                    ]}
                    resizeMode="contain"
                  />
                </View>
              </View>
            )}
            {SidebarData.map((item, index) => {
              return (
                <SubMenu
                  subnav={subnav}
                  setSubnav={setSubnav}
                  item={item}
                  key={index}
                  currentUser={currentUser}
                  showSidebar={showSidebar}
                  setShowSidebar={setShowSidebar}
                />
              )
            })}
          </View>

        </View>

        {/** SHOW SIDEBAR BUTTON - desktop only */}
        {!(isMobile || isTablet) && (
          <TouchableOpacity
            style={{
              alignSelf: showSidebar ? "flex-end" : "center",
              marginRight: showSidebar ? 12 : 0,
              marginBottom: 12,
            }}
            onPress={() => setShowSidebar(!showSidebar)}
          >
            {showSidebar ? (
              <FaIcons.FaChevronLeft size={20} color={COLORS.primary.darkBlue} />
            ) : (
              <FaIcons.FaChevronRight size={20} color={COLORS.primary.darkBlue} />
            )}
          </TouchableOpacity>
        )}
      </SidebarNav>
      {showProfileMenu && (
        <View style={styles.profileMenu}>
          <TouchableOpacity style={styles.menuButton} onPress={changePasswordPressed}>
            <PrimaryText
              fontSize={12}
              fontWeight={300}
              style={styles.userName}
              numberOfLines={1}
            >
              Change Password
            </PrimaryText>
            <FaIcons.FaKey size={20} color={COLORS.primary.darkGray} />
          </TouchableOpacity>
          <TouchableOpacity style={styles.menuButton} onPress={logoutPressed}>
            <PrimaryText
              fontSize={12}
              fontWeight={300}
              style={styles.userName}
              numberOfLines={1}
            >
              Logout
            </PrimaryText>
            <FaIcons.FaSignOutAlt size={20} color={COLORS.primary.darkGray} />
          </TouchableOpacity>
        </View>
      )}
      {showChangePasswordModal && (
        <View style={styles.modalLayer}>
          <ChangePasswordModal
            setShowModal={() => setShowChangePasswordModal(false)}
          />
        </View>
      )}
    </>
  )
}

const styles = StyleSheet.create({
  companyInfoContainer: {
    marginVertical: 12,
    marginHorizontal: 12,
    zIndex: 999,
  },
  rayzeContainer: {
    alignItems: "center",
    justifyContent: "center",
  },
  logo: {
    height: 60,
    width: 100,
    resizeMode: "contain",
    marginBottom: 12,
  },

  companyName: {
    fontSize: 16,
    color: COLORS.primary.black,
    marginVertical: 12,
    textAlign: "center",
  },
  showSidebarButton: {
    alignSelf: "center",
  },

  //top bar
  topBar: {
    position: "fixed",
    top: 0,
    width: "100%",
    zIndex: 999,
    flexDirection: "row",
    paddingHorizontal: 12,
    backgroundColor: COLORS.primary.offWhite,
    height: 80,
    justifyContent: "flex-end",
    alignItems: "center",

    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
  },
  notificationContainer: {
    backgroundColor: COLORS.primary.green,
    height: 36,
    width: 36,
    borderRadius: 18,
    justifyContent: "center",
    alignItems: "center",
  },
  userContainer: {
    flexDirection: "row",
    // justifyContent:'space-around',
    alignItems: "center",
  },
  userIcon: {
    backgroundColor: COLORS.primary.darkGray,
    height: 36,
    width: 36,
    borderRadius: 18,
    overflow: "hidden",
    justifyContent: "center",
    alignItems: "center",
  },
  profilePic: {
    width: "100%",
    height: "100%",
    resizeMode: "cover",
  },
  userName: {
    fontSize: 14,
    lineHeight: 24,
    color: COLORS.primary.darkGray,
  },
  profileMenu: {
    position: "absolute",
    zIndex: 1,
    backgroundColor: COLORS.primary.white,
    right: 0,
    top: 80,
    height: 80,
    width: 200,
    paddingHorizontal: 12,

    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 3.5,
    },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
  },
  modalLayer: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 1001,
  },
  menuButton: {
    flexDirection: "row",
    width: "100%",
    height: 40,
    justifyContent: "space-between",
    alignItems: "center",
  },
})

export default Sidebar
